export const FetchPriority = ({ item }) => ({
  item: {
    ...item,
    fetchPriority: item.rootPosition <= 4 ? 'high' : 'low'
  }
})
